import Box from 'src/components/Box';
import Card from 'src/components/Card';
import adGraphicsGuide from 'src/assets/images/ad-graphics-size-guide.png';

interface Resource {
  name: string;
  category: string;
  snippet: string;
  link: string;
  imageUrl: string;
}

const resources: Resource[] = [
  {
    name: 'Ad graphics size guide',
    category: 'Content & Social Media',
    snippet: 'Call tracking, recording, and more.',
    link: 'https://www.figma.com/proto/NbD0Ml1LfGVmFcLYaib9Rr/SGM-Guides-Client?page-id=0%3A1&node-id=88-6357&p=f&viewport=1290%2C708%2C0.1&t=csCcBdDWfLM3dilv-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=88%3A6357',
    imageUrl: adGraphicsGuide,
  },
  {
    name: 'CallRail',
    category: 'Call Tracking',
    snippet: 'Call tracking, recording, and more.',
    link: 'https://www.callrail.com/pricing?gspk=Y2hyaXN0b3BoZXJzYXZhZ2UxNDU5&gsxid=wm03X651D3Ud&pscd=partners.callrail.com&utm_campaign=partnerstack&utm_medium=agency_referral&utm_source=christophersavage1459',
    imageUrl: '/assets/CallRail.png',
  },
  {
    name: 'Constant Contact Email Marketing',
    category: 'Email marketing',
    snippet:
      "Email marketing, campaign management, and more (we've been a partner since we opened our doors in 2014).",
    link: 'https://www.constantcontact.com/signup?pn=savageglobalmarketing',
    imageUrl: '/assets/ConstantContact.png',
  },
  {
    name: 'GoHighLevel',
    category: 'Sales & CRM',
    snippet:
      'Sales management, automated follow-ups, and sales workflows to close deals.',
    link: 'https://www.gohighlevel.com/annual?fp_ref=savage-global-marketing94',
    imageUrl: '/assets/GoHighLevel.png',
  },
  {
    name: 'Grant access to advertising/social',
    category: 'Content & Social Media',
    snippet:
      'The easiest way to provide access to Google, Facebook & TikTok assets.',
    link: 'https://app.leadsie.com/connect/sgm/manage',
    imageUrl: '/assets/Leadsie.png',
  },
  {
    name: 'Grant access to social media',
    category: 'Content & Social Media',
    snippet:
      'The easiest way to provide access to Google, Facebook & TikTok assets.',
    link: 'https://app.leadsie.com/connect/request/64677cdf6fdeb8ba93ec2ee2',
    imageUrl: '/assets/Leadsie.png',
  },
  {
    name: 'Voiceover (Male/Female) - English',
    category: 'Voice Over',
    snippet: 'English voice over for videos',
    link: 'https://lionshare-prd.s3.us-west-2.amazonaws.com/cms/ENGLISH_VO_SAMPLES_44113d3a8a.mov',
    imageUrl: '/assets/Voiceover.png',
  },
  {
    name: 'Voiceover (Male/Female) - Spanish',
    category: 'Studio',
    snippet: 'Spanish Voice over for videos',
    link: 'https://lionshare-prd.s3.us-west-2.amazonaws.com/cms/SPANISH_VO_0717b9459b.mov',
    imageUrl: '/assets/Voiceover.png',
  },
];

const ClientResource = () => {
  return (
    <Box>
      <div className="mb-4 space-y-2">
        <p className="text-2xl font-bold text-blue-700 lg:text-3xl">
          Resources
        </p>

        <p>
          Here are some resources that have helped us a lot over the years. We
          can’t promise success every time, but they’ve worked great for us!
        </p>
      </div>

      <div className="grid grid-flow-row gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {resources.map((resource) => (
          <Card
            key={resource.name}
            name={resource.name}
            category={resource.category}
            link={resource.link}
            imageUrl={resource.imageUrl}
            externalLink
          >
            {resource.snippet}
          </Card>
        ))}
      </div>
    </Box>
  );
};

export default ClientResource;
